import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { HowToHandleOption } from 'src/app/components/adjustments/execution-collapse/display-not-executed-history-item/display-not-executed-history-item-helper';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _post, DeserializeVoid } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class HandleNotExecutedSubProjectControllerRequestService {
  private static BASE_URL = '/immo/handleNotExecutedSubProject';
  private readonly post: <T>(
    path: string,
    body: RequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      HandleNotExecutedSubProjectControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public handleNotExecutedSubProject(
    subProjectId: number,
    howToHandle: HowToHandleOption,
    delayedReason: string,
    delayHandlerId: number,
    handleDelayByDate: moment.Moment,
    newEmployeeId: number,
    newTourDate: moment.Moment,
    appointmentFollowUpEmployeeId: number,
    appointmentFollowUpDate: moment.Moment
  ): Promise<void> {
    const requestBody: RequestBody = this.constructRequestBody(
      subProjectId,
      howToHandle,
      delayedReason,
      delayHandlerId,
      handleDelayByDate,
      newEmployeeId,
      newTourDate,
      appointmentFollowUpEmployeeId,
      appointmentFollowUpDate
    );
    return this.post('', requestBody, DeserializeVoid).toPromise();
  }

  private constructRequestBody(
    subProjectId: number,
    howToHandle: HowToHandleOption,
    delayedReason: string,
    delayHandlerId: number,
    handleDelayByDate: moment.Moment,
    newTourEmployeeId: number,
    newTourDate: moment.Moment,
    appointmentFollowUpEmployeeId: number,
    appointmentFollowUpDate: moment.Moment
  ): RequestBody {
    return {
      subProjectId: subProjectId,
      delaySubProject: howToHandle === HowToHandleOption.DELAY,
      delayedReason: delayedReason,
      delayHandlerId: delayHandlerId,
      handleDelayByDate: handleDelayByDate,
      rescheduleAppointment:
        howToHandle === HowToHandleOption.RESCHEDULE_APPOINTMENT,
      removeFromCurrentTour:
        howToHandle === HowToHandleOption.REMOVE_FROM_CURRENT_TOUR,
      setStatusToExecuted:
        howToHandle === HowToHandleOption.SET_STATUS_TO_EXECUTED,
      setStatusToNotExecuted:
        howToHandle === HowToHandleOption.SET_STATUS_TO_NOT_EXECUTED ||
        howToHandle === HowToHandleOption.INVOICE_PARTIALLY,
      invoicePartially: howToHandle === HowToHandleOption.INVOICE_PARTIALLY,
      newTourEmployeeId: newTourEmployeeId,
      newTourDateString:
        newTourDate == null ? null : newTourDate.format('YYYYMMDD'),
      appointmentFollowUpEmployeeId: appointmentFollowUpEmployeeId,
      appointmentFollowUpDate: appointmentFollowUpDate,
    };
  }
}

interface RequestBody {
  subProjectId: number;
  delaySubProject: boolean;
  delayedReason: string;
  delayHandlerId: number;
  handleDelayByDate: moment.Moment;
  rescheduleAppointment: boolean;
  removeFromCurrentTour: boolean;
  setStatusToExecuted: boolean;
  setStatusToNotExecuted: boolean;
  invoicePartially: boolean;
  newTourEmployeeId: number;
  newTourDateString: string;
  appointmentFollowUpEmployeeId: number;
  appointmentFollowUpDate: moment.Moment;
}
